export default {"id":"b8d3e1d9","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}